export const apiConstants = {
  url: "/api/labeltype",
  doortypes: "/api/doortype",
  company: "/api/company"
};
